"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectSuspendedUsers = exports.hubUserInfoEndpointTest = exports.portalIdBody = exports.retryOnError = exports.logoutOnUnauthorizedOrForbidden = exports.recyclePromise = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _index = require("../index");

var _update = require("../helpers/update");

var _core = require("./core");

var _hubapi = require("./hubapi");

var _url = require("../helpers/url");

var _location = require("../helpers/location");

var _promise = require("../helpers/promise");

var _response = require("../helpers/response");

var _toggleable = _interopRequireDefault(require("../decorators/toggleable"));

var recycledResponse = function recycledResponse(response) {
  return response.xhr.readyState === 0 ? {
    status: response.status,
    statusText: response.statusText,
    data: response.data
  } : response.xhr;
};

var withRecycledResponse = function withRecycledResponse(options) {
  return function (response) {
    return (0, _update.set)('externalResponse', recycledResponse(response))(options);
  };
};

var recyclePromise = function recyclePromise(options) {
  if (options.recycledPromise) {
    return options.recycledPromise.then(withRecycledResponse(options), withRecycledResponse(options));
  } else {
    return options;
  }
};

exports.recyclePromise = recyclePromise;

var isUnauthorizedOrForbidden = function isUnauthorizedOrForbidden(response) {
  return response.status === 403 || response.status === 401;
};

var logoutOnUnauthorizedOrForbidden = (0, _hubapi.logoutOn)(isUnauthorizedOrForbidden);
exports.logoutOnUnauthorizedOrForbidden = logoutOnUnauthorizedOrForbidden;
var retryOnError = (0, _core.retry)(function (response) {
  return response.status !== 200 && !isUnauthorizedOrForbidden(response);
}, {
  reason: 'Error fetching user data',
  maxRetries: 3,
  onMaxAttemptsReached: _hubapi.logoutOnError
});
exports.retryOnError = retryOnError;

var portalIdBody = function portalIdBody(options) {
  return (0, _update.set)('data', {
    portalId: options.portalId
  })(options);
};

exports.portalIdBody = portalIdBody;

var buildDashboardUrl = function buildDashboardUrl(options) {
  var hostname = (0, _core.resolveApi)((0, _core.standardApi)('app', 'hubspot'));
  var portalId = options.portalId || '';
  var dashboardDescriptor = {
    hostname: hostname,
    path: "/dashboard/" + portalId
  };
  return (0, _url.buildUrl)(dashboardDescriptor);
};

var redirectToDashboard = function redirectToDashboard(response) {
  var options = response.options;
  var redirectUrl = buildDashboardUrl(options);
  return (0, _location.redirectTo)(redirectUrl, options) ? _promise.Promise.reject((0, _response.responseError)(response, 'Aborting: redirection in progress')) : response;
};

var shouldRedirectForSuspension = function shouldRedirectForSuspension(response) {
  return !response.options.allowSuspended && response.data.user && Array.isArray(response.data.user.scopes) && response.data.user.scopes.indexOf('suspended') !== -1;
};

var hubUserInfoEndpointTest = (0, _index.createStack)(function (options) {
  return (0, _core.withUrl)(function (url) {
    if (url.path === '/login-verify') {
      return (0, _extends2.default)({}, url, {
        path: '/login-verify/hub-user-info'
      });
    }

    return url;
  })(options);
}, (0, _core.method)('GET'), (0, _core.environmentUrl)((0, _core.standardApi)('api', 'hubspot')), function (options) {
  return (0, _core.query)({
    portalId: options.portalId
  })(options);
});
exports.hubUserInfoEndpointTest = hubUserInfoEndpointTest;
var redirectSuspendedUsers = (0, _toggleable.default)(function (isEnabled) {
  return function (options) {
    if (!isEnabled()) return options;
    return (0, _core.onResponse)(function (response) {
      if (shouldRedirectForSuspension(response)) {
        return redirectToDashboard(response);
      }

      return response;
    })(options);
  };
});
exports.redirectSuspendedUsers = redirectSuspendedUsers;